export default "__VITE_ASSET__uqAPii$r__"